// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","wrapper":"Header_wrapper__SXTn0","logot2":"Header_logot2__yfr7T","divider":"Header_divider__G58kM","logofts":"Header_logofts__QsbiK"};